module.exports = __webpack_public_path__ + "static/media/sieugene.d5b20231.png";